import { axiosInstance } from "../../../hoc/Axios/Axios";
import * as actions from "../../Actions";

export const getMinimumRates = params => dispatch => axiosInstance
    .get("/minimum-rates", { params })
    .then(response => {
        dispatch({ type: actions.GET_MINIMUM_RATES, payload: response.data.data })
    })
    .catch(() => null)
